
import React from 'react';
import { 
  Code, Figma, Github, Database, Server, 
  LineChart, FileText, FileCode, Table, Calculator,
  PenTool, PaintBucket, Brush, Layers, Laptop,
  MonitorSmartphone, Cpu, Home, Box, Building,
  Chrome, Cloud, Slack, Trello, Instagram,
  Facebook, Twitter, Linkedin, Coins, DollarSign,
  Bot, BrainCog, Zap, Terminal, Network,
} from 'lucide-react';

interface TechnologyIcon {
  icon: React.ReactNode;
  label: string;
}

// Define icons by category
const iconsByCategory: Record<string, TechnologyIcon[]> = {
  'tech': [
    { icon: <Code size={16} />, label: 'JavaScript' },
    { icon: <FileCode size={16} />, label: 'React' },
    { icon: <Server size={16} />, label: 'Node.js' },
    { icon: <Database size={16} />, label: 'SQL' },
    { icon: <Github size={16} />, label: 'GitHub' },
    { icon: <Cpu size={16} />, label: 'Cloud' },
    { icon: <MonitorSmartphone size={16} />, label: 'Responsive' },
  ],
  'creative': [
    { icon: <Figma size={16} />, label: 'Figma' },
    { icon: <PenTool size={16} />, label: 'Illustrator' },
    { icon: <PaintBucket size={16} />, label: 'Photoshop' },
    { icon: <Brush size={16} />, label: 'Digital Art' },
    { icon: <Layers size={16} />, label: 'Sketch' },
    { icon: <Instagram size={16} />, label: 'Social Media' },
  ],
  'business': [
    { icon: <LineChart size={16} />, label: 'Analytics' },
    { icon: <Table size={16} />, label: 'Excel' },
    { icon: <FileText size={16} />, label: 'CMS' },
    { icon: <Laptop size={16} />, label: 'Marketing' },
    { icon: <Trello size={16} />, label: 'Project Mgmt' },
    { icon: <Slack size={16} />, label: 'Collaboration' },
  ],
  'finance': [
    { icon: <Calculator size={16} />, label: 'QuickBooks' },
    { icon: <LineChart size={16} />, label: 'Forecasting' },
    { icon: <Table size={16} />, label: 'Excel' },
    { icon: <Database size={16} />, label: 'Databases' },
    { icon: <Coins size={16} />, label: 'Accounting' },
    { icon: <DollarSign size={16} />, label: 'Financial Tools' },
  ],
  'architecture': [
    { icon: <Home size={16} />, label: 'AutoCAD' },
    { icon: <Building size={16} />, label: 'Revit' },
    { icon: <PenTool size={16} />, label: 'SketchUp' },
    { icon: <Layers size={16} />, label: '3D Modeling' },
    { icon: <Box size={16} />, label: 'Blender' },
    { icon: <Brush size={16} />, label: 'Rendering' },
  ],
  'ai': [
    { icon: <BrainCog size={16} />, label: 'Machine Learning' },
    { icon: <Bot size={16} />, label: 'Chatbots' },
    { icon: <Zap size={16} />, label: 'Automation' },
    { icon: <Terminal size={16} />, label: 'NLP' },
    { icon: <Network size={16} />, label: 'Neural Networks' },
    { icon: <Cloud size={16} />, label: 'AI Cloud' },
  ],
};

export const getTechnologyIconsByCategory = (category: string): TechnologyIcon[] => {
  return iconsByCategory[category] || iconsByCategory['tech'];
};

export default iconsByCategory;
